export const commonEnvironment = {
    applicationId: 'ab08074a-5903-48eb-98e2-da5f46ffcadf',
    defaultPermPrefix: 'rtb2',
    routePermissions: [],
    googleTagManager: {
        id: 'GTM-MZQB8LG',
    }
};
